import React from "react";
import RegistrationSvgIcon from "./RegistrationSvgIcon";

export default function ShowPassIcon({ color = "#B1B1B1" }) {
  const ShowPassIconSVG = `
<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.75 7.75C13.75 8.54565 13.4339 9.30871 12.8713 9.87132C12.3087 10.4339 11.5456 10.75 10.75 10.75C9.95435 10.75 9.19129 10.4339 8.62868 9.87132C8.06607 9.30871 7.75 8.54565 7.75 7.75C7.75 6.95435 8.06607 6.19129 8.62868 5.62868C9.19129 5.06607 9.95435 4.75 10.75 4.75C11.5456 4.75 12.3087 5.06607 12.8713 5.62868C13.4339 6.19129 13.75 6.95435 13.75 7.75Z" stroke="${color}" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M0.75 7.75C2.35 3.653 6.086 0.75 10.75 0.75C15.414 0.75 19.15 3.653 20.75 7.75C19.15 11.847 15.414 14.75 10.75 14.75C6.086 14.75 2.35 11.847 0.75 7.75Z" stroke="${color}" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
`;
  return <RegistrationSvgIcon xml={ShowPassIconSVG} width={20} height={14} />;
}
